/**
 * @file scroll-top.js
 * @description 页面滚动元素获取方法集合，兼容不同浏览器
 */

/**
 * 获取滚动条在Y轴上的滚动距离
 *
 * @return {number} scrollTop 滚动条距页面顶部距离
 */
export const getScrollTop = () => {
    let scrollTop = 0;
    let bodyScrollTop = 0;
    let documentScrollTop = 0;
    if (document.body) {
        bodyScrollTop = document.body.scrollTop;
    }
    if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
    }
    scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop;
    return scrollTop;
};

/**
 * 获取页面内容的高度
 *
 * @return {number} scrollHeight 页面内容高度
 */
export const getScrollHeight = () => {
    let scrollHeight = 0;
    let bodyScrollHeight = 0;
    let documentScrollHeight = 0;
    if (document.body) {
        bodyScrollHeight = document.body.scrollHeight;
    }
    if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight;
    }
    scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight;
    return scrollHeight;
};

/**
 * 获取浏览器视口高度
 *
 * @return {number} windowHeight 浏览器高度
 */
export const getWindowHeight = () => {
    let windowHeight = 0;
    if (document.compatMode === 'CSS1Compat') {
        windowHeight = document.documentElement.clientHeight;
    }
    else {
        windowHeight = document.body.clientHeight;
    }
    return windowHeight;
};

/**
 * 获取元素距顶部高度
 *
 * @param {string} id 元素 id
 * @return {number} offsetTop 元素距顶部高度
 */
export const getOffsetTop = id => {
    const event = document.getElementById(id);
    if (event) {
        return event.offsetTop;
    }
    return null;
};
